import React from 'react'
import Navibar from './Navibar'
import styles from './styles/Home.module.css'
import ShowcaseFooter from './Footer'
import CollectionLayout from './CollectionLayout'

export default function WorksPage(props) {
  let matchDownMd = false
  const collectionId = props.collectionId ?? 'all'
  const layout = () => {
    if (!props.collection) return null
    if (collectionId === 'all') {
      const itemLayout = []
      props.collection.results.forEach((item) => {
        itemLayout.push(
          CollectionLayout({
            title: item.title,
            itemData: item.artworks,
            matchDownMd: matchDownMd
          })
        )
      })
      return itemLayout
    } else {
      try {
        const collection = props.collection.results[collectionId - 1]
        return CollectionLayout({
          title: collection.title,
          itemData: collection.artworks,
          matchDownMd: matchDownMd
        })
      } catch (e) {
        return null
      }
    }
  }

  return (
    <div style={{ overflowX: 'hidden' }}>
      <Navibar {...props} />
      <main className={styles.main}>
        <div
          style={{
            width: '100%',
            paddingLeft: '4px',
            paddingRight: '4px'
          }}
        >
          {layout()}
        </div>
      </main>
      <ShowcaseFooter />
    </div>
  )
}
